import "./App.css";

import dxConfig from 'devextreme/core/config';
import React, { useState, useEffect } from "react";
import NewOrder from "./newOrder";
import OrderStatus from "./orderStatus/orderStatus";
import OrderDetail from "./orderStatus/orderDetail";
import Invoice from "./invoices/invoices";
import Login from "./login";
import Tracking from "./tracking";
import OrderHistory from "./history";
import TrackingOrderDetail from "./orderStatus/trackingOrderDetail";
import { useUserContext} from "./lib/user_context";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import HttpRequest from "./HttpService";
import { theme } from "./theme";
import { ThemeProvider } from "@mui/material/styles";
import NavigationBar from "./NavigationBar";
import NotificationBanner from "./NotificationBanner";
import WDWebview from "./WDWebview";
import ExtendWeb from "./ExtendWeb";
import Preferences from "./preferences";
import Success from "./checkout/Success";
import Canceled from "./checkout/Canceled";
import axios from "axios";


// DevExtreme started enforcing licenses with v22.2; without this the grids
// render an "evaluation only" banner. The key is supplied via env var so it
// stays out of the repo — set REACT_APP_DEVEXTREME_LICENSE_KEY in Azure App
// Service Configuration. Inlined into the bundle at build time by CRA.
if (process.env.REACT_APP_DEVEXTREME_LICENSE_KEY) {
  dxConfig({ licenseKey: process.env.REACT_APP_DEVEXTREME_LICENSE_KEY });
} else if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-console
  console.warn('REACT_APP_DEVEXTREME_LICENSE_KEY not set — DevExtreme grids will show the evaluation banner.');
}


function App() {

  const [loginUser, setLoginUser] = useState({});
  const [loginInfo, setLoginInfo] = useState({});
  const [userAddress, setUserAddress] = useState({});
  const [accountList, setAccountList] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // const [apiVersion, setAPIVersion] = useState("1.1.0");
  const [webEmbedded, setWebEmbedded] = useState(false);

  const headerRef = React.useRef(null);

  const {updateToken,updateAccount,updateLoginUser,updateIsEmbedded,updatePreviousOrder,updateAccountAddress,updateIPAddress} = useUserContext();
  const { sessionToken,sessionAccount,sessionLoginUser,sessionLoginInfo,sessionAccountAddress, sessionIP, previousOrder, isEmbedded, sessionPreference} = useUserContext();

  useEffect(() => {
    const updateHeaderHeight = () => {
      if (headerRef.current) {
        const height = headerRef.current.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }
    };

    const resizeObserver = new ResizeObserver(updateHeaderHeight);
    if (headerRef.current) {
      resizeObserver.observe(headerRef.current);
    }

    updateHeaderHeight();

    return () => resizeObserver.disconnect();
  }, []);

  useEffect(() => {
    console.log("App sessionToken is", sessionToken);
  },[sessionToken]);

  useEffect(() => {
    console.log("App sessionAccount is", sessionAccount);
  },[sessionAccount]);

  useEffect(() => {
    console.log("App sessionAccountAddress is", sessionAccountAddress);
    setUserAddress(sessionAccountAddress);
  },[sessionAccountAddress]);

  useEffect(() => {
    console.log("App sessionLoginInfo is", sessionLoginInfo);
    setLoginInfo(sessionLoginInfo);
  },[sessionLoginInfo]);

  useEffect(() => {
    console.log("App isEmbedded is", isEmbedded);
    setWebEmbedded(isEmbedded)
  },[isEmbedded]);

  useEffect(() => {
    console.log("App sessionLoginUser is", sessionLoginUser);
    if(sessionLoginUser !== null){
      setLoginUser(sessionLoginUser);
      localStorage.setItem("accountNumber", sessionLoginUser.accountNumber);
      setIsAuthenticated(true);
          let groupID = sessionLoginUser.groupID;
          console.log("sessionLoginUser groupID --" + groupID);
          if (groupID !== null) {
            HttpRequest.getGroupAccounts(groupID).then(async function (body) {
              console.log("getGroupAccounts:" + JSON.stringify(body.data));
              let accounts =  body.data.map((person,i) => {
                return {id:i, value: person.account,label: person.accountName};
              });
              if (accounts.length > 0) {
                setAccountList(accounts);
              } else {
                setAccountList([{id:1,value:sessionLoginUser.accountNumber,label:sessionLoginUser.accountNumber}]);
              }
            }).catch(function (error) {
              console.error("getGroupAccounts error:", error);
              setAccountList([{id:1,value:sessionLoginUser.accountNumber,label:sessionLoginUser.accountNumber}]);
            });
          }
          else{
            setAccountList([{id:1,value:sessionLoginUser.accountNumber,label:sessionLoginUser.accountNumber}]);
          }
    }
  },[sessionLoginUser]);

  useEffect(() => {
    console.log("App sessionLoginUser is", sessionAccountAddress);
  },[sessionAccountAddress]);

  useEffect(() => {
    let token = "";
    console.log("App wondow token is", window.token);
    console.log("App url is", window.location.href);

    token = window.location.href.split("sso_token=")[1];
    console.log("App token", token);

  }, []);


  return (
    <ThemeProvider theme={theme}>
      <React.Fragment>
        <Router>
          <div ref={headerRef} style={{ position: 'sticky', top: 0, zIndex: 1100, backgroundColor: 'white' }}>
            <NavigationBar
              isLoggedIn={isAuthenticated}
              accountList={accountList}
              account={sessionAccount || (sessionLoginUser && sessionLoginUser.accountNumber)}
              updateGlobalAccount={updateAccount}
            />
            <NotificationBanner sessionToken={sessionToken} />
          </div>
          <Routes>
            <Route path="/"  element={!isAuthenticated ? <Login/>
              : <NewOrder accountList={accountList} loginInfo={loginInfo}  account={sessionAccount || (sessionLoginUser && sessionLoginUser.accountNumber)} isEmbedded={webEmbedded} updateGlobalAccount={updateAccount}/> }>
            </Route>
            <Route path="/neworder" element={
              <NewOrder accountList={accountList} loginInfo={loginInfo} account={sessionAccount || (sessionLoginUser && sessionLoginUser.accountNumber)} isEmbedded={webEmbedded} updateGlobalAccount={updateAccount}/>}>
            </Route>
            <Route path="/neworder/:quoteID" element={
                <NewOrder accountList={accountList} loginInfo={loginInfo} account={sessionAccount || (sessionLoginUser && sessionLoginUser.accountNumber)} isEmbedded={webEmbedded} updateGlobalAccount={updateAccount}/>}>
            </Route>
            <Route path="/orderstatus"  element={
              <OrderStatus account={sessionAccount} isEmbedded={webEmbedded}/>}>
            </Route>
            <Route path="/orderDetail/:orderID/:account"  element={
              <OrderDetail variant="orderStatus" account={loginUser.accountNumber} isEmbedded={webEmbedded}/>}>
            </Route>
            <Route  path="/trackOrderDetail/:orderID/:account" element={
              <OrderDetail variant="orderTrack" account={loginUser.accountNumber} isEmbedded={webEmbedded}/>}>
            </Route>
            <Route path="/invoices" element={<Invoice  account={loginUser.accountNumber} isEmbedded={webEmbedded}/>} />
            <Route path="/history" element={<OrderHistory isEmbedded={webEmbedded}/>} />
            <Route path="/faq" element={<WDWebview url={Number(sessionPreference?.companyID) === 5 ? "https://arguscarriers.com/" : "https://www.directitgroup.ca/faq"} isEmbedded={webEmbedded} />}/>
            <Route path="/web/:webtype" element={<ExtendWeb isEmbedded={webEmbedded}/>}/>
            <Route path="/preferences" element={<Preferences isEmbedded={webEmbedded} address={userAddress}/>} />
            <Route path="/tracking" element={<Tracking type="none" isEmbedded={webEmbedded}/>} />
            <Route path="/trackNo/:trackingNumber" element={<TrackingOrderDetail trakingType="trackingNumber"/>} />
            <Route exact path="/TrackAccount/:trackingAccount/:trackingReference"
                elelment={<TrackingOrderDetail trakingType="reference"/>} />
            <Route path="/success" element={<Success />}/>
            <Route path="/canceled" element={<Canceled />}/>
            {/*
            <Route>
              <div>Page not found!</div>
            </Route> */}
          </Routes>
        </Router>
      </React.Fragment>
    </ThemeProvider>
  );
}

export default App;